export default __webpack_public_path__ + "static/media/car-sharing.c97feb1d.svg";